// eslint-disable-next-line import/prefer-default-export
export function jsUcfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function truncateString(string, maxLength = 50) {
  if (!string) return null;
  if (string.length <= maxLength) return string;
  return `${string.substring(0, maxLength)}...`;
};



// WEBPACK FOOTER //
// ./src/utils/textUtils.js